
import Vue from "vue";
import App from "./App";
import router from "./router";

import store from './store';


import ElementUI from "element-ui";

//更改主题色
import "./element-css/index.css";
import "./assets/css/index.css";
import axios from "axios";
import less from "less";
Vue.use(less);
import * as echarts from "echarts";
import Print from "./utils/print.js"; //路径根据项目结构引入
Vue.prototype.$print = Print;
import KeyboardInput from "./components/keyboard-input";
import KeyboardNumberInput from "./components/keyboard-number-input.vue";

if (window.startOsk) Vue.prototype.showKeyBoard = window.startOsk;
import MyMixin from "../src/utils/mixin.js";
import { keyboardInputMixin } from "./mixin/keyBoard";




// mixinMethods 相关函数
import mixinMethods from '@/tools/mixinMethods.js'
Object.keys(mixinMethods).forEach(methodsName => Vue.prototype[methodsName] = mixinMethods[methodsName])
console.log('mixinMethods==>', {
    len: Object.keys(mixinMethods).length,
    mixinMethods,
});



Vue.mixin(MyMixin);
Vue.mixin(keyboardInputMixin);
Vue.component("KeyboardInput", KeyboardInput);
Vue.component("KeyboardNumberInput", KeyboardNumberInput);
Vue.use(Print);
Vue.prototype.$echarts = echarts;
Vue.prototype.$less = less;

Vue.prototype.$axios = axios;

Vue.use(ElementUI);

Vue.config.productionTip = false;


const gvm = new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});

window.gvm = gvm;



// WEBPACK FOOTER //
// ./src/main.js